import React from 'react';

export default ({ listValues, onClick, name }) => {
    const data = listValues || [];

    return (
        <div className="form__row">
            <ul className="autosuggest__dropdown">
                {data.map((item, index) => {
                    let resultIndent = !!item.parentId
                        ? 'autosuggest__result-indent'
                        : 'autosuggest__result';
                    return (
                        <li
                            key={index}
                            data-index={index}
                            onClick={onClick}
                            className={resultIndent}
                        >
                            {name === 'qualifiedName'
                                ? item.qualifiedName
                                : item.name}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/ui/auto-suggest.js